import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIRefresh = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 560",
	width: "1em",
	height: "1em",
	className: "g-icon",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M320 146s24.36-12-64-12a160 160 0 10160 160",
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeMiterlimit: 10,
		strokeWidth: 32
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 32,
		d: "M256 58l80 80-80 80"
	})]
});
export default SvgIRefresh;
